export default __webpack_public_path__ + "static/media/Unicorn.502329b8.svg";